<template>
  <button
    v-bind="$attrs"
    :class="[
      disabled ? 'disabled': type,
      { 'mobile-button': isMobile },
      { 'button-large': size === 'large' }
    ]"
    @click="onClick"
  >
    <slot />
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useClientCompatibleHook } from '@/utils/hooks'
enum TYPE {
  submit = 'submit',
  normal = 'normal',
  disabled = 'disabled',
}

enum SIZE {
  normal = 'normal',
  large = 'large'
}

const Button = defineComponent({
  props: {
    type: {
      type: String,
      default: TYPE.submit
    },
    size: {
      type: String,
      default: SIZE.normal
    },
    // isMobile: {
    //   type: Boolean,
    //   default: false
    // },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  setup (props, context) {
    const { isMobile } = useClientCompatibleHook()
    const { emit } = context

    const onClick = (e: Event) => {
      if (!props.disabled) {
        emit('click', e)
      }
    }

    return {
      onClick,
      isMobile
    }
  }
})

Button.TYPE = TYPE

export default Button
</script>

<style lang="less" scoped>
.common-button-style {
  min-width: 88px;
  padding: 0 16px;
  text-align: center;
  white-space: nowrap;
}
.submit {
  .common-button-style();
  background: @theme-color;
  color: #fff;
  cursor: pointer;
  border: none;
  .radius--box(32px);
  // submit按钮增加悬停色
  &:hover {
    background: #C1120B;
  }
}

.disabled {
  .submit;
  opacity: 0.4;
  cursor: not-allowed;
}
.normal{
  .common-button-style();
  cursor: pointer;
  border: 1px solid #DDDDDD;
  background: #FFFFFF;
  color: #333333;
  .radius--box(32px);
  line-height: 30px;
  &:hover {
    color: @theme-color;
    border-color: @theme-color;
  }
}

.button-large {
  height: 36px;
  line-height: 36px;
  font-weight: 600;
  border-radius: 18px;
}

button.mobile-button {
  height: 3.2rem;
  padding: 0 1rem;
  min-width: 8.8rem;
  font-size: 1.4rem;
  text-align: center;
  line-height: 1.4rem;
  font-weight: 400;
  border-radius: 2rem;
}
button.mobile-button.button-large {
  height: 4rem;
  line-height: 4rem;
  font-weight: 600;
}
</style>
